import { useState } from 'react';
import { Calendar, Check } from 'lucide-react';
import apiClient from '../lib/api';

interface GoogleConnectButtonProps {
  isConnected?: boolean;
}

export default function GoogleConnectButton({ isConnected = false }: GoogleConnectButtonProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConnect = async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await apiClient.get<{ url: string }>('/auth/google/url');
      
      // Redirect to Google OAuth
      window.location.href = data.url;
    } catch (err: any) {
      setError(err.response?.data?.detail || 'התחלת החיבור ל-Google Calendar נכשלה');
      setLoading(false);
    }
  };

  if (isConnected) {
    return (
      <div className="flex items-center gap-2 text-green-600">
        <Check className="w-5 h-5" />
        <span className="text-sm font-medium">מחובר ✅</span>
      </div>
    );
  }

  return (
    <div>
      {error && (
        <p className="mb-2 text-sm text-red-600">{error}</p>
      )}
      <button
        onClick={handleConnect}
        disabled={loading}
        className="flex items-center justify-center gap-2 px-4 py-2.5 bg-white border border-gray-300 rounded-md text-gray-700 font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors min-h-[44px] w-full sm:w-auto"
      >
        <Calendar className="w-5 h-5" />
        <span className="text-sm sm:text-base">{loading ? 'מתחבר...' : 'חבר Google Calendar'}</span>
      </button>
    </div>
  );
}
